const cards = [
  ["Clientes ativos", "0"],
  ["Ambientes", "0"],
  ["Ativos com memória", "0"],
  ["OS abertas", "0"],
  ["Confiança média", "0%"]
];

export function DashboardPage() {
  return (
    <section>
      <div className="page-heading">
        <div>
          <span className="eyebrow">Visão operacional</span>
          <h1>Dashboard</h1>
          <p>Qualidade da memória técnica, conectividade, atendimento e integrações.</p>
        </div>
        <button type="button" className="primary">Nova ordem</button>
      </div>

      <div className="stat-grid">
        {cards.map(([label, value]) => (
          <article className="stat-card" key={label}>
            <span>{label}</span>
            <strong>{value}</strong>
            <small>Aguardando conexão com a API</small>
          </article>
        ))}
      </div>

      <div className="content-grid">
        <article className="panel">
          <h2>Lacunas de conhecimento</h2>
          <div className="empty-state">Nenhum ativo analisado. Importe a base e calcule a confiança.</div>
        </article>
        <article className="panel">
          <h2>Saúde das integrações</h2>
          <dl className="status-list">
            <div><dt>Timeline</dt><dd>Contrato pronto</dd></div>
            <div><dt>DE→PARA</dt><dd>Contrato pronto</dd></div>
            <div><dt>Digital Twin</dt><dd>Aguardando dados</dd></div>
          </dl>
        </article>
      </div>
    </section>
  );
}
